import Swiper, { Autoplay } from 'swiper';

import 'swiper/swiper.scss';

Swiper.use(Autoplay);

(() => {
    const headerImageCarousel = document.querySelector(
        '[data-header-image-carousel]'
    );

    if (headerImageCarousel) {
        new Swiper(headerImageCarousel, {
            // eslint-disable-line no-new
            autoplay: {
                delay: 5000,
            },
            loop: true,
            centeredSlides: true,
            centeredSlidesBounds: true,
            observer: true,
            observeSlideChildren: true,
            slidesPerView: 1,
            slideToClickedSlide: true,
            spaceBetween: 30,
            watchOverflow: true,
        });
    }
})();
